<div class="flex align-items-center justify-content-center w-full font-bold  m-2 text-3xl title-case">
    Unit Status
</div>

<div class="mb-2">
    <p-card>
        <form [formGroup]="unitStatusForm">
            <div class="formgroup-inline  flex justify-content-center">
                <div class="field">
                    <label for="partnerId" class="required-field font-bold">PAC :</label>
                    <p-autoComplete appendTo="body" [dropdown]="true" placeholder="Search for PAC" formControlName="pac"
                        [suggestions]="pacList" (completeMethod)="filterList($event)" (Keydown.enter)="onSearchPac()"
                        (onDropdownClick)="fillpacList();moveSelectedToTop();">
                    </p-autoComplete>
                    <div *ngIf="formControls.pac.errors" class="error-msg flex ml-7">
                        <!-- If invalid input(pattern error) and doesnot exceed maxlength-->
                        <div *ngIf="formControls.pac.errors?.pattern">
                            PAC should be alpha numeric
                        </div>
                        <!-- If valid input(pattern error) and exceeds maxlength-->
                        <div *ngIf="formControls.pac.errors?.maxlength && !formControls.pac.errors?.pattern">
                            Maximum length of the PAC should be 13
                        </div>
                        <div *ngIf="formControls.pac.errors?.minlength && !formControls.pac.errors?.pattern">
                            Minimum length of the PAC should be 12
                        </div>
                    </div>
                </div>
                <div class="field">
                    <button pButton type="button" label="Search" icon="pi pi-search" (click)="onSearchPac()"
                        [disabled]="unitStatusForm.invalid" class="btn-request-status"></button>
                </div>
            </div>
        </form>
    </p-card>
</div>

<div class="" *ngIf="isDataAvailable">
    <p-card>
        <fieldset class="col-12">
            <legend>Unit Status Info</legend>
            <p-table [value]="unitStatusInfo" dataKey="contractId" selectionMode="multiple" [responsive]="true"
                [columns]="column">
                <ng-template pTemplate="header" let-columns>
                    <tr style="word-break: break-word;">
                        <th style="width: 3em;"></th>
                        <th *ngFor="let col of columns">
                            {{col.header}}
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-statuses let-expanded="expanded" let-rowIndex="rowIndex">
                    <tr>
                        <td>
                            <button type="button" pButton pRipple [pRowToggler]="statuses"
                                class="p-button-text p-button-rounded p-button-plain"
                                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                        </td>
                        <td>{{statuses.contractId}}</td>
                        <td>{{statuses.pac}}</td>
                        <td>{{statuses.productCode}}</td>
                        <td>{{statuses.contractService}}</td>
                        <td>{{statuses.statusDescription}}</td>
                        <td>{{statuses.serviceCoverage}}</td>
                        <td>{{statuses.manufacturer}}</td>
                        <td>{{statuses.activationStartDate | date: "MMM dd yyyy HH:mm"}}</td>
                        <td>{{statuses.contractEndDate | date: "MMM dd yyyy HH:mm"}}</td>
                    </tr>
                </ng-template>


                <ng-template pTemplate="rowexpansion" let-rowData let-columns="column">
                    <tr>
                        <td colspan="7" [attr.colspan]="column.length + 1" class="table-td">
                            <div class="grid">
                                <div class="col-12 md:col-6 lg:col-6">
                                    <div class="grid" style="align-items: center;">
                                        <div class="col-5" style="text-align: right">
                                            <label for="pac" class="lbl-fontfamily">Transaction
                                                Date :</label>
                                        </div>
                                        <div class="col-7 data-fontfamily"
                                            style="text-align:left;vertical-align: middle">
                                            {{rowData.transactionDate | date: "MMM dd yyyy"}}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 md:col-6 lg:col-6">
                                    <div class="grid" style="align-items: center;">
                                        <div class="col-5" style="text-align: right">
                                            <label for="pac" class="lbl-fontfamily">Market Sector
                                                :</label>
                                        </div>
                                        <div class="col-7 data-fontfamily"
                                            style="text-align:left;vertical-align: middle">
                                            {{rowData.marketSector}}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="grid">
                                <div class="col-12 md:col-6 lg:col-6">
                                    <div class="grid" style="align-items: center;">
                                        <div class="col-5" style="text-align: right">
                                            <label for="pac" class="lbl-fontfamily">Country Code
                                                :</label>
                                        </div>
                                        <div class="col-7 data-fontfamily"
                                            style="text-align:left;vertical-align: middle">
                                            {{rowData.countryCode}}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 md:col-6 lg:col-6">
                                    <div class="grid" style="align-items: center;">
                                        <div class="col-5" style="text-align: right">
                                            <label for="pac" class="lbl-fontfamily">Country Name
                                                :</label>
                                        </div>
                                        <div class="col-7 data-fontfamily"
                                            style="text-align:left;vertical-align: middle">
                                            {{rowData.countryName}}
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="grid">
                                <div class="col-12 md:col-6 lg:col-6">
                                    <div class="grid" style="align-items: center;">
                                        <div class="col-5" style="text-align: right">
                                            <label for="pac" class="lbl-fontfamily">Contract Duration
                                                :</label>
                                        </div>
                                        <div class="col-7 data-fontfamily"
                                            style="text-align:left;vertical-align: middle">
                                            {{rowData.contractDuration}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 md:col-6 lg:col-6">
                                    <div class="grid" style="align-items: center;">
                                        <div class="col-5" style="text-align: right">
                                            <label for="pac" class="lbl-fontfamily">Contract Type
                                                :</label>
                                        </div>
                                        <div class="col-7 data-fontfamily"
                                            style="text-align:left;vertical-align: middle">
                                            {{rowData.contractType}}
                                        </div>
                                    </div>
                                </div>


                            </div>

                            <div class="grid">
                                <div class="col-12 md:col-6 lg:col-6">
                                    <div class="grid" style="align-items: center;">
                                        <div class="col-5" style="text-align: right">
                                            <label for="pac" class="lbl-fontfamily">Geogating
                                                Mode:</label>
                                        </div>
                                        <div class="col-7 data-fontfamily"
                                            style="text-align:left;vertical-align: middle">
                                            {{rowData.geogatingMode}}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 md:col-6 lg:col-6">
                                    <div class="grid" style="align-items: center;">
                                        <div class="col-5" style="text-align: right">
                                            <label for="status" class="lbl-fontfamily">Beams
                                                :</label>
                                        </div>
                                        <div class="col-7 data-fontfamily"
                                            style="text-align:left;vertical-align: middle">
                                            {{rowData.beams}}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="grid">
                                <div class="col-12 md:col-6 lg:col-6">
                                    <div class="grid" style="align-items: center;">
                                        <div class="col-5" style="text-align: right">
                                            <label for="status" class="lbl-fontfamily">Field 1
                                                :</label>
                                        </div>
                                        <div class="col-7 data-fontfamily"
                                            style="text-align:left;vertical-align: middle">
                                            {{rowData.field1}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 md:col-6 lg:col-6">
                                    <div class="grid" style="align-items: center;">
                                        <div class="col-5" style="text-align: right">
                                            <label for="pac" class="lbl-fontfamily">Field 2
                                                :</label>
                                        </div>
                                        <div class="col-7 data-fontfamily"
                                            style="text-align:left;vertical-align: middle">
                                            {{rowData.field2}}
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="grid">
                                <div class="col-12 md:col-6 lg:col-6">
                                    <div class="grid" style="align-items: center;">
                                        <div class="col-5" style="text-align: right">
                                            <label for="status" class="lbl-fontfamily">Field 3
                                                :</label>
                                        </div>
                                        <div class="col-7 data-fontfamily"
                                            style="text-align:left;vertical-align: middle">
                                            {{rowData.field3}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </fieldset>
    </p-card>
</div>

<p-toast position="top-center" life="4000"></p-toast>